export function getFormattedUTCDateFromString(dateString) {
  const date = new Date(Date.parse(dateString))
  const UTC = date.toUTCString(date).split(' ')
  const UTCTime = UTC[4]?.split(':')[0] + ':' + UTC[4].split(':')[1]
  const formated = UTC[1] + ' ' + UTC[2] + ' ' + UTC[3] + ' ' + UTCTime + ' UTC'
  return formated
}
